<style lang="less" scoped>
    .division {
        height: 100%;
        width: 100%;
        display: flex;
        .flex-division {
            flex:1
        }
        .left-contain {
            float: right;
            // position: relative;
            height: 100%;
            width: 50%;
            .top {
              height: 50%;
              // border-right: solid 0.5px #D7DAE2;
              border-bottom: solid 1px #D7DAE2;
            }
            .bottom {
              height: 50%;
              border-left: solid 1px #D7DAE2;
            }
        }
        .right-contain {
            float: left;
            // position: relative;
            height: 100%;
            width: 50%;
            .top {
              height: 50%;
              border-left: solid 0.5px #D7DAE2;
              border-bottom: solid 1px #D7DAE2;
            }
            .bottom {
              height: 50%;
              border-right: solid 1px #D7DAE2;
            }
        }
    }
</style>
<template>
  <div class="division">
    <div class="flex-division">
      <div class="left-contain">
        <div class="top" />
        <div class="bottom" />
      </div>
    </div>
    <div class="flex-division">
      <div class="right-contain">
        <div class="top" />
        <div class="bottom" />
      </div>
    </div>
  </div>
</template>
<script>
  export default {
     
  }
</script>
